import usePrivateAxios from "@/common/api/usePrivateAxios";
import { unFormatCurrency } from "@/common/utils/unFormatters";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

interface CreateEstablishmentProductData {
  product_id: {
    label: string
    value: string
  };
  metric: string;
  branch_id?: string;
}

interface UseCreateEstablishmentProductParams {
  onSuccess: () => void;
  onError?: (error: AxiosError) => void;
}

export const useCreateEstablishmentProduct = ({ onSuccess, onError }: UseCreateEstablishmentProductParams) => {
  const privateAxios = usePrivateAxios()

  const { mutate, isPending } = useMutation<void, AxiosError, CreateEstablishmentProductData>({
    mutationKey: ['createEstablishmentProduct'],
    mutationFn: async (data) => {
      await privateAxios.post("/establishment/product_prices", {
        product_price: {
          product_id:data.product_id.value,
          value: unFormatCurrency(data.metric),
          branch_id:data.branch_id
        }
      });

    },
    onSuccess,
    onError,
  });

  return { mutate, isPending };
};
